export default "__VITE_ASSET__DS9jKc34__"